import { combineReducers } from 'redux';
import { reducer as toastrReducer } from 'react-redux-toastr';
import { authorization } from './authorization';

export default combineReducers({
  authorization,
  toastr: toastrReducer,
});
